module.exports = __webpack_public_path__ + "img/box6.861bc068.png";